let componentLoaderInstance = null
let classDefinitions = null

/**
 * ComponentLoader
 *
 * This class is used for resolving DOM elements within markup to javascript "components".
 *
 * @param {Object} _params - Parameters with the
 * @param {Object} _params.onComponentsLoaded - Callback that fires when all components have been loaded
 * @param {Object} _params.onComponentsUnloaded - Callback that fires when all components have been unloaded
 */
class ComponentLoader {
  constructor (_params) {
    const params = Object.assign({
      onComponentsLoaded: null,
      onComponentsUnloaded: null
    }, _params)

    this.onComponentsLoaded = params.onComponentsLoaded
    this.onComponentsUnloaded = params.onComponentsUnloaded
  }

  /**
   * Loads an individual component
   * @param {DOM Element} element - The DOM element of the component
   */
  loadComponent (element) {
    const $el = $(element)
    const componentName = $el.attr('data-component')

    if (typeof classDefinitions[componentName] === 'function') {
      const classInstance = new classDefinitions[componentName](element)
      $el.data('component', classInstance)
      $el.attr('data-instance', true)
    } else {
      console.log(`Error trying to load "${componentName}" :: class not found.`)
    }
  }

  /**
   * Unloads an individual component
   * @param {DOM Element} element - The DOM element of the component
   */
  unloadComponent (element) {
    const $el = $(element)
    const classInstance = $el.data('component')

    if (typeof classInstance.unload === 'function') {
      classInstance.unload()
    }
    $el.removeData('component')
    $el.removeAttr('data-instance')
  }

  /**
   * Load all components, within a defined element (or document body by default)
   * @param {DOM Element} [element=body] - The DOM element to target component loading (optional).
   */
  loadComponents (element) {
    const $el = element ? $(element) : $('body')

    $el.find('[data-component]:not([data-instance])').each((index, element) => {
      this.loadComponent(element)
    })

    if (typeof this.onComponentsLoaded === 'function') {
      this.onComponentsLoaded($el)
    }
  }

  /**
   * Unload all components, within a defined element (or document body by default)
   * @param {DOM Element} [element=body] - The DOM element to target component unloading (optional).
   */
  unloadComponents (element) {
    const $el = element ? $(element) : $('body')

    $el.find('[data-instance]').each((index, element) => {
      this.unloadComponent(element)
    })

    if (typeof this.onComponentsUnloaded === 'function') {
      this.onComponentsUnloaded($el)
    }
  }
}

/**
 * Instantiate a new ComponentLoader. This function is not meant for general use, instead use getComponentLoader.
 * @param {Object} [params] - Parameters for the ComponentLoader, see class definition for details (optional).
 */
export function newComponentLoader (params) {
  componentLoaderInstance = new ComponentLoader(params)
  return componentLoaderInstance
}

/**
 * Singleton pattern for the ComponentLoader.
 * @param {Object} [params] - Parameters for the ComponentLoader, see class definition for details (optional).
 */
export function getComponentLoader (params) {
  if (!componentLoaderInstance) {
    componentLoaderInstance = newComponentLoader(params)
  }
  return componentLoaderInstance
}

/**
 * Register class definition for use later
 * @param {String} [className] - The name of the class.
 * @param {Class} [classDefinition] - The class reference.
 */
export function registerClass (className, classDefinition) {
  classDefinitions = classDefinitions || []
  if (classDefinitions[className]) {
    throw new Error(`Error :: classDefinitions[${className}] already defined.`)
  }
  classDefinitions[className] = classDefinition
}
